"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DumbappArgumentsVariable = void 0;
exports.dumbappArgumentsValue = dumbappArgumentsValue;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _VariableType = require("../VariableType");
var _remeda = require("remeda");
var _VarsValueTypeHandler = require("../../type/VarsValueTypeHandler");
var _types = require("../../types");
// This format makes it simpler to use the values as both an ordered array,
// and a map, depending on what it's used for. Contract read calls want
// arrays, dumbapps want maps.

function dumbappArgumentsValue(value, names, prefill, form) {
  return new _VarsValueTypeHandler.VarsMetaValue(value, "dumbapp-arguments", {
    names,
    prefill,
    form
  });
}
class DumbappArgumentsVariable extends _VariableType.VarsValueVariableType {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "settings", DumbappArgumentsVariable.settings);
    (0, _defineProperty2.default)(this, "type", "dumbapp-arguments");
    (0, _defineProperty2.default)(this, "label", "Dumbapp Arguments");
    (0, _defineProperty2.default)(this, "description", "Load a set of argument values for a dumbapp.");
  }
  dependencies(params, resolver) {
    let values = [];
    let names = [];
    let prefill = [];
    let form = [];
    if (Array.isArray(params.values)) {
      for (let it of params.values) {
        if (!it.value) {
          // Without a value definition, push undefined to signify that the value
          // should come from a different source.
          values.push(undefined);
        } else {
          let res = resolver.resolve(it.value);
          let value = _types.vals.value(res);
          values.push(value);
        }
        names.push(it.name);
        prefill.push(!!it.prefill);
        form.push(!!it.form);
      }
    }
    return {
      values,
      names,
      prefill,
      form
    };
  }
  value(deps) {
    if (!deps) {
      return null;
    }
    return dumbappArgumentsValue((0, _remeda.clone)(deps.values), deps.names, deps.prefill, deps.form);
  }
}
exports.DumbappArgumentsVariable = DumbappArgumentsVariable;
(0, _defineProperty2.default)(DumbappArgumentsVariable, "settings", {
  values: {
    type: "args",
    title: "Values",
    description: "Argument values for the dumbapp."
  }
});
//# sourceMappingURL=DumbappArgumentsVariable.js.map